export class AvgMinMax {
  min;
  max;
  cnt;
  total;

  constructor(val) {
    this.total = this.min = this.max = val;
    this.cnt = 1;
  }

  addData(val) {
    this.cnt++;
    this.total += val;
    if (val < this.min) {
      this.min = val;
    } else if (val > this.max) {
      this.max = val;
    }
  }

  avg() {
    return this.total / this.cnt;
  }
}
